// extracted by mini-css-extract-plugin
export default {"checkbox-group":"styles_checkbox-group__GeAmi","space":"styles_space__AmYaL","letters":"styles_letters__V+mdb","letters-active":"styles_letters-active__bmCAF"};